import React, { useEffect, useState } from "react";
import Barra from "../components/Barra";
import TabAlumnos from "../components/admin/TabAlumnos";
import TabFranjas from "../components/admin/TabFranjas";
import TabPreguntas from "../components/admin/TabPreguntas";
import TabUsuarios from "../components/admin/TabUsuarios";
import TabHistorial from "../components/admin/TabHistorial";
import PanelFueraDeHora from "../components/PanelFueraDeHora";
import PanelAdmisiones from "../components/PanelAdmisiones";
import PanelEnsombrado from "../components/PanelEnsombrado";
import PanelCheckin from "../components/PanelCheckin";

// El admin lo puede hacer todo: sus propias pestañas + las áreas de admisiones, ensombrado y check-in.
const TABS = [
  { clave: "alumnos", texto: "🎓 Alumnos" },
  { clave: "franjas", texto: "📅 Franjas" },
  { clave: "preguntas", texto: "❓ Preguntas" },
  { clave: "usuarios", texto: "👥 Usuarios" },
  { clave: "fuera", texto: "🕒 Fuera de hora" },
  { clave: "historial", texto: "📜 Historial" },
  { clave: "admisiones", texto: "💬 Admisiones" },
  { clave: "ensombrado", texto: "🏷️ Ensombrado" },
  { clave: "checkin", texto: "✅ Check-in" },
];
const CLAVE = "checkin_admin_tab";

export default function Admin() {
  const [tab, setTab] = useState(() => {
    try { const t = localStorage.getItem(CLAVE); return TABS.some((x) => x.clave === t) ? t : "alumnos"; } catch { return "alumnos"; }
  });
  useEffect(() => { try { localStorage.setItem(CLAVE, tab); } catch { /* sin almacenamiento */ } }, [tab]);

  return (
    <div className="app-shell">
      <Barra titulo="Admin" tabs={TABS} tab={tab} onTab={setTab} />
      {tab === "alumnos" && <TabAlumnos />}
      {tab === "franjas" && <TabFranjas />}
      {tab === "preguntas" && <TabPreguntas />}
      {tab === "usuarios" && <TabUsuarios />}
      {tab === "fuera" && <PanelFueraDeHora esAdmin />}
      {tab === "historial" && <TabHistorial />}
      {tab === "admisiones" && <PanelAdmisiones />}
      {tab === "ensombrado" && <PanelEnsombrado />}
      {tab === "checkin" && <PanelCheckin />}
    </div>
  );
}
